export const STATUS_UNAUTHORIZED=401
export const STATUS_VALIDATION_ERROR=422